import * as React from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { ResourceType } from '@shared/utils';
import { buttonVariants } from '../../functions/buttonVariants';
import type { ButtonProps } from '../../types/ButtonProps';

// Local implementation of cn utility
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * @group Components
 * @summary <blockquote>A versatile button component with multiple variants and sizes.</blockquote>
 * @example
 * ```tsx
 * <Button variant="default" size="lg">
 *   Click me
 * </Button>
 * ```
 */
const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    return (
      <button
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);

Button.displayName = 'Button';
export { Button };

// Using ResourceType makes this component discoverable as a UI resource
const authConfig = {
  type: ResourceType.UI,
  // Button is now discoverable for permission control
};
